import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  basicsettinglist,
  updateApiinfo,
  UpdateKycstatus,
  Invoicestatus,
  Performancestatustatus,
  PotentialStatusChange,
  TelegramStatusChange,
} from "../../../Services/Admin/Admin";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";

const Apiinfo = () => {
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("id");
  const navigate = useNavigate();

  const [clients, setClients] = useState("");
  const [kycstatus, setKycstatus] = useState({
    kyc: "",
  });

  const [initialApiData, setInitialApiData] = useState({
    digio_client_id: "",
    digio_client_secret: "",
    digio_template_name: "",
  });
  const [updateapi, setUpdateapi] = useState({
    digio_client_id: "",
    digio_client_secret: "",
    digio_template_name: "",
  });
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const getApidetail = async () => {
    try {
      const response = await basicsettinglist(token);
      if (response?.status && response?.data) {
        const clientData = response.data[0];
        setClients(clientData);
        setKycstatus(clientData);

        setUpdateapi({
          digio_client_id: clientData.digio_client_id || "",
          digio_client_secret: clientData.digio_client_secret || "",
          digio_template_name: clientData.digio_template_name || "",
        });
        setInitialApiData({
          digio_client_id: clientData.digio_client_id || "",
          digio_client_secret: clientData.digio_client_secret || "",
          digio_template_name: clientData.digio_template_name || "",
        });
      }
    } catch (error) {
      console.log("Error fetching API details:", error);
    }
  };

  useEffect(() => {
    getApidetail();
  }, []);

  useEffect(() => {
    const isDataChanged =
      updateapi.digio_client_id !== initialApiData.digio_client_id ||
      updateapi.digio_client_secret !== initialApiData.digio_client_secret ||
      updateapi.digio_template_name !== initialApiData.digio_template_name;

    setIsButtonDisabled(!isDataChanged);
  }, [updateapi, initialApiData]);

  const UpdateApi = async () => {
    try {
      if (!updateapi.digio_client_id || !updateapi.digio_client_secret) {
        showCustomAlert("error", "Please fill all the required fields.");
        return;
      }
      const data = {
        id: user_id,
        digio_client_id: updateapi.digio_client_id,
        digio_client_secret: updateapi.digio_client_secret,
        digio_template_name: updateapi.digio_template_name,
      };

      const response = await updateApiinfo(data, token);

      if (response?.status) {
        showCustomAlert(
          "Success",
          "Your API information was updated successfully."
        );
        getApidetail();
      }
    } catch (error) {
      showCustomAlert(
        "error",
        "There was an error updating the API information. Please try again."
      );
    }
  };

  const handleSwitchChange = async (newValue) => {
    const result = await showCustomAlert(
      "confirm",
      "Do you want to change the KYC status?"
    );
    // console.log("result",result)
    if (result.isConfirmed) {
      try {
        const response = await UpdateKycstatus({ kyc: newValue }, token);
        if (response.status) {
          showCustomAlert("Success", "KYC status updated successfully!");
          getApidetail();
        }
      } catch (error) {
        showCustomAlert("error", "There was an error updating the KYC status.");
      }
    }
  };

  const handleSwitchChange1 = async (event) => {
    const originalChecked = event.target.checked;
    const user_active_status = originalChecked ? 1 : 0;
    const data = { invoicestatus: user_active_status };
    const result = await showCustomAlert(
      "confirm",
      "Do you want to change the status?"
    );

    if (result.isConfirmed) {
      try {
        const response = await Invoicestatus(data, token);
        if (response.status) {
          showCustomAlert("Success", "Status changed successfully!");
          getApidetail();
        }
      } catch (error) {
        showCustomAlert("error", "There was an error processing your request.");
      }
    } else {
      event.target.checked = !originalChecked;
      getApidetail();
    }
  };

  const handleSwitchChange2 = async (event) => {
    const originalChecked = event.target.checked;
    const user_active_status = originalChecked ? 1 : 0;
    const data = { performancestatus: user_active_status };
    const result = await showCustomAlert(
      "confirm",
      "Do you want to change the status?"
    );

    if (result.isConfirmed) {
      try {
        const response = await Performancestatustatus(data, token);
        if (response.status) {
          showCustomAlert("Success", "Status changed successfully!");
          getApidetail();
        }
      } catch (error) {
        showCustomAlert("error", "There was an error processing your request.");
      }
    } else {
      event.target.checked = !originalChecked;
      getApidetail();
    }
  };

  const handlePotentialToggle = async (event) => {
    const originalChecked = event.target.checked;
    const status = originalChecked ? 1 : 0;

    const result = await showCustomAlert(
      "confirm",
      "Do you want to change the Potential status?"
    );

    if (result.isConfirmed) {
      try {
        const response = await PotentialStatusChange(
          { potentialstatus: status },
          token
        );

        if (response?.status) {
          showCustomAlert("Success", "Potential status updated successfully!");
          getApidetail();
        }
      } catch (err) {
        showCustomAlert("error", "Error updating Potential status.");
      }
    } else {
      // ❌ cancel → toggle revert
      event.target.checked = !originalChecked;
      getApidetail();
    }
  };

  const handleTelegramToggle = async (event) => {
    const originalChecked = event.target.checked;
    const status = originalChecked ? 1 : 0;

    const result = await showCustomAlert(
      "confirm",
      "Do you want to change the Telegram status?"
    );

    if (result.isConfirmed) {
      try {
        const response = await TelegramStatusChange(
          { telegramstatus: status },
          token
        );

        if (response?.status) {
          showCustomAlert("Success", "Telegram status updated successfully!");
          getApidetail();
        }
      } catch (err) {
        showCustomAlert("error", "Error updating Telegram status.");
      }
    } else {
      // ❌ cancel → toggle revert
      event.target.checked = !originalChecked;
      getApidetail();
    }
  };

  return (
    <div>
      <div className="page-content">
        <div className="page-breadcrumb  d-flex align-items-center mb-3">
          <div className="breadcrumb-title pe-3">Api Information</div>
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard">
                    <i className="bx bx-home-alt" />
                  </Link>
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <hr />

        <div className="row row-cols-12 justify-content-center">
          <div className="col">
            <div className="card">
              <div className="card-header mt-2">
                <div className="row align-items-center">
                  {/* KYC Status */}
                  <div className="col-md-3">
                    <h5>KYC Status</h5>
                  </div>

                  <div className="col-md-2">
                    <select
                      className="form-select"
                      value={kycstatus?.kyc}
                      onChange={(e) => handleSwitchChange(e.target.value)}
                    >
                      <option value={0}>None</option>
                      <option value={2}>After Payment</option>
                      <option value={1}>Before Payment</option>
                    </select>
                  </div>

                  {/* Invoice Status */}
                  <div className="col-md-3 text-center">
                    <h5>Invoice Status</h5>
                  </div>

                  <div className="col-md-1 d-flex justify-content-center">
                    <div className="form-check form-switch form-check-info">
                      <input
                        id={`invoice_${kycstatus?._id}`}
                        className="form-check-input toggleswitch"
                        type="checkbox"
                        checked={kycstatus?.invoicestatus == 1}
                        onChange={handleSwitchChange1}
                      />
                      <label
                        htmlFor={`invoice_${kycstatus?._id}`}
                        className="checktoggle checkbox-bg"
                      ></label>
                    </div>
                  </div>

                  {/* Performance Status */}
                  <div className="col-md-2 text-center">
                    <h5>Performance Status</h5>
                  </div>

                  <div className="col-md-1 d-flex justify-content-center">
                    <div className="form-check form-switch form-check-info">
                      <input
                        id={`performance_${kycstatus?._id}`}
                        className="form-check-input toggleswitch"
                        type="checkbox"
                        checked={kycstatus?.performancestatus == 1}
                        onChange={handleSwitchChange2}
                      />
                      <label
                        htmlFor={`performance_${kycstatus?._id}`}
                        className="checktoggle checkbox-bg"
                      ></label>
                    </div>
                  </div>

                  <div className="col-md-2 text-center">
                    <h5>Potential Status</h5>
                  </div>

                  <div className="col-md-1 d-flex justify-content-center">
                    <div className="form-check form-switch form-check-info">
                      <input
                        className="form-check-input toggleswitch"
                        type="checkbox"
                        checked={kycstatus?.potentialstatus == 1}
                        onChange={handlePotentialToggle}
                      />
                    </div>
                  </div>

                  <div className="col-md-2 text-center">
                    <h5>Telegram Status</h5>
                  </div>

                  <div className="col-md-1 d-flex justify-content-center">
                    <div className="form-check form-switch form-check-info">
                      <input
                        className="form-check-input toggleswitch"
                        type="checkbox"
                        checked={kycstatus?.telegramstatus == 1}
                        onChange={handleTelegramToggle}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header mt-2">
                <div className="row justify-content-end mb-3">
                  <h5>Digio API Key</h5>
                </div>
              </div>

              <div className="card-body mt-2">
                <form className="row g-3 mt-2 mb-3">
                  <div className="row">
                    <div className="col-md-12 mb-2">
                      <label htmlFor="digioTemplateName" className="form-label">
                        Template Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="digioTemplateName"
                        disabled={kycstatus?.kyc !== 0}
                        value={updateapi.digio_template_name}
                        onChange={(e) =>
                          setUpdateapi({
                            ...updateapi,
                            digio_template_name: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-md-12 mb-2">
                      <label htmlFor="digioClientId" className="form-label">
                        Digio Client ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="digioClientId"
                        disabled={kycstatus?.kyc !== 0}
                        value={updateapi.digio_client_id}
                        onChange={(e) =>
                          setUpdateapi({
                            ...updateapi,
                            digio_client_id: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-md-12 mb-2">
                      <label htmlFor="digioClientSecret" className="form-label">
                        Digio Client Secret
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="digioClientSecret"
                        disabled={kycstatus?.kyc !== 0}
                        value={updateapi.digio_client_secret}
                        onChange={(e) =>
                          setUpdateapi({
                            ...updateapi,
                            digio_client_secret: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div className="card-footer text-end">
                <button
                  type="button"
                  className="btn btn-primary mb-2"
                  onClick={UpdateApi}
                  disabled={isButtonDisabled || kycstatus.kyc !== 0}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Apiinfo;
